import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { State } from 'models';

import { getCurrentCooperative } from 'store/home/selectors';

import { InvestorLiabilitiesDetails } from 'components';

const InvestorLiabilites = () => {
  const { coopId, coopName } = useSelector((state: State) => ({
    coopId: state.settings.current_cooperative,
    coopName: getCurrentCooperative(state)?.Name || null,
  }));

  const fileName = useMemo(() => {
    return `investor_liabilities__${coopName}`;
  }, [coopName]);

  return (
    <InvestorLiabilitiesDetails
      fileName={fileName}
      url={`/api/portfolios/${coopId}/liabilities`}
    />
  );
};

export default InvestorLiabilites;
